export function getAllUrlParams(url) {
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  var obj = {};

  if (queryString) {
    queryString = queryString.split("#")[0];

    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split("=");
      var paramName = a[0];
      var paramValue = typeof a[1] === "undefined" ? true : a[1] + "==";
      if (paramName.match(/\[(\d+)?\]$/)) {
        var key = paramName.replace(/\[(\d+)?\]/, "");
        if (!obj[key]) obj[key] = [];

        if (paramName.match(/\[\d+\]$/)) {
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          obj[key].push(paramValue);
        }
      } else {
        if (!obj[paramName]) {
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === "string") {
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

export const FormHeader = () => {
  return (
    <div className="  bg-gray-800 py-5 pl-3">
      <h1 className="text-white ml-20 text-2xl">
        Permohonan Pengkursus Ibadat Haji Tanah Air (PEKTA)
      </h1>
      <div className="flex flex-row">
        <div className=" flex flex-col ">
          <div className="h-1 w-64 bg-green-600 ml-20 mt-5"> </div>
          <br />
          <p className="text-white ml-20 text-sm">Maklumat Diri Anda</p>
          <p className=" text-sm text-gray-400 ml-20">
            Pastikan nama dan informasi adalah tepat
          </p>
        </div>

        <div className=" flex flex-col">
          <div className="h-1 w-64 bg-white ml-4 mt-5"> </div>
          <br />
          <p className="text-white ml-4 text-sm">Kelulusan Akademik</p>
          <p className=" text-sm text-gray-400 ml-4">
            Pastikan nama dan informasi adalah tepat
          </p>
        </div>

        <div className=" flex flex-col">
          <div className="h-1 w-64 bg-white ml-4 mt-5"> </div>
          <br />
          <p className="text-white ml-4 text-sm">Muat Naik Dokumen</p>
          <p className=" text-sm text-gray-400 ml-4">
            Pastikan nama dan informasi adalah tepat
          </p>
        </div>

        <div className=" flex flex-col">
          <div className="h-1 w-64 bg-white ml-4 mt-5"> </div>
          <br />
          <p className="text-white ml-4 text-sm">Pengakuan</p>
          <p className=" text-sm text-gray-400 ml-4">
            Pastikan nama dan informasi adalah tepat
          </p>
        </div>
      </div>
    </div>
  );
};

export const FormMobile = () => {
  return (
    <div className="  bg-gray-800 py-5 pl-3">
      <h1 className="text-white ml-20 text-2xl">
        Permohonan Pengkursus Ibadat Haji Tanah Air (PEKTA)
      </h1>
      <div className="flex flex-row">
        <div className=" flex flex-col ">
          <div className="h-1 w-64 bg-green-600 ml-20 mt-5"> </div>
          <br />
          <p className="text-white ml-20 text-sm">Maklumat Diri Anda</p>
          <p className=" text-sm text-gray-400 ml-20">
            Pastikan nama dan informasi adalah tepat
          </p>
        </div>
      </div>
    </div>
  );
};

export function storeGet(item) {
  return localStorage.getItem(`${item}`);
}
